import { render, staticRenderFns } from "./PaymentFailure.vue?vue&type=template&id=2fb0a51a&scoped=true"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailure.vue?vue&type=style&index=0&id=2fb0a51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0a51a",
  null
  
)

export default component.exports